export default __webpack_public_path__ + "static/media/screen3.0da41708.png";